import React, { useState, useEffect } from 'react';
import { FooterSkeleton } from '@ldp-web/component-library/ui/skeletons/footer-skeleton';

/**
 * Renders FooterSkeleton only after client mount to avoid Emotion className
 * hydration mismatch (Chakra Skeleton emits different class hashes on server vs client).
 * Server and first client paint render a stable placeholder.
 */
export function ClientOnlyFooterSkeleton() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <div
        data-testid="footer-skeleton-placeholder"
        style={{ minHeight: 240 }}
        aria-hidden="true"
      />
    );
  }

  return <FooterSkeleton />;
}
